import { useQuery } from '@tanstack/react-query';
import { DEFAULT_STRAPI_STALE_TIME } from '@betterpool/strapi-client';

import getSlides from './getSlides';

const PLATFORM = 'web';

const useGetSlides = () =>
  useQuery({
    queryKey: ['cms@slideshowSignup', PLATFORM],
    queryFn: () => getSlides({ platform: PLATFORM }),
    staleTime: DEFAULT_STRAPI_STALE_TIME,
  });

export default useGetSlides;
